import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import taskSvg from '@/assets/task_alt.svg';
import { trackCtaClick } from '@/lib/trackCtaClick.ts';
import { scrollToApplyForm } from '@/lib/scroll';

export const Hero = () => {
  const { t } = useTranslation();
  const handleApplyClick = () => {
    trackCtaClick('hero');
    scrollToApplyForm();
  };

  return (
    <div className="flex flex-col items-center gap-6 px-4 py-8 mb-8">
      {/* Badge */}
      <Badge
        variant="outline"
        className="bg-green-50 text-primary border-0 rounded-full text-sm font-medium"
      >
        <img src={taskSvg} alt="" className="w-4 h-4 mr-1" />
        {t('landing.hero.hiredThisMonth')}
      </Badge>

      {/* Main Headline */}
      <h1 className="text-3xl md:text-4xl font-bold text-center">
        {t('landing.hero.title')}{' '}
        <span className="text-primary">
          {t('landing.hero.title.timeRange')}
        </span>
      </h1>

      {/* Description */}
      <p className="text-base text-muted-foreground text-center font-light">
        {t('landing.hero.subtitle')}{' '}
        <span className="font-medium">
          {t('landing.hero.subtitle.aiPlatform')}
        </span>{' '}
        {t('landing.hero.subtitle.andMatched')}
      </p>

      <div className="flex flex-col items-center gap-3">
        {/* CTA Button */}
        <Button
          variant="accent"
          shape="rounded"
          size="lg"
          className="w-full max-w-xs"
          onClick={handleApplyClick}
        >
          {t('landing.hero.cta')}
        </Button>

        {/* Benefits */}
        <div className="flex flex-wrap items-center justify-center gap-4 mt-2 text-muted-foreground">
          <div className="flex items-center gap-1">
            <img src={taskSvg} alt="" className="w-4 h-4" />
            <span className="text-sm font-medium">
              {t('landing.hero.benefits.free')}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <img src={taskSvg} alt="" className="w-4 h-4" />
            <span className="text-sm font-medium">
              {t('landing.hero.benefits.noResume')}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <img src={taskSvg} alt="" className="w-4 h-4" />
            <span className="text-sm font-medium">
              {t('landing.hero.benefits.realEmployers')}
            </span>
          </div>
        </div>
      </div>

      {/* Statistics */}
      <div className="flex items-center justify-center gap-8 pt-6 border-t border-border w-full">
        <div className="flex flex-col items-center">
          <span className="text-2xl text-primary font-bold">1k+</span>
          <span className="text-xs text-muted-foreground">
            {t('landing.hero.stats.jobsPosted')}
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-2xl text-primary font-bold">24h</span>
          <span className="text-xs text-muted-foreground">
            {t('landing.hero.stats.avgResponse')}
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-2xl text-primary font-bold">500+</span>
          <span className="text-xs text-muted-foreground">
            {t('landing.hero.stats.businesses')}
          </span>
        </div>
      </div>
    </div>
  );
};
